import React, { useEffect, useState } from 'react';
import AOS from 'aos';

import client from 'apollo';
import history from './utils/history';
import queries from './apollo/queries';

import 'aos/dist/aos.css';

// Router
import Router from './router';
import ServerUnavailable from './components/Errors/ServerUnavailable';

// Intenationalization
import I18nextProviderC from './config/i18n';

import ScrollToTop from 'components/ScrollToTop';

// Style
import './style.sass';

import GA from './utils/GoogleAnalytics';
import ipapi from  'ipapi.co';

AOS.init({ duration: 2000, offset: 300, delay: 1000 });

const getLocation = () => {
  const locale = localStorage.getItem('locale');
  if (!locale){
    ipapi.location((data) => {
      if(data) {
        const languages = data.languages;
        const mainLanguage = languages.split(',');

        if (mainLanguage.length > 0 && mainLanguage[0].includes('es-')){
          localStorage.setItem('locale', 'es');
        }else {
          localStorage.setItem('locale', 'en');
          window.location.reload();
        }
      }
    });
  }
}

function App() {
  const [health, setHealth] = useState(true);

  getLocation();
  
  useEffect(() => {
    checkForMobile();
  }, []);

  useEffect(() => {
    serverHealthCheck();
  }, []);


  const checkForMobile = () => {
    if (
      /android/i.test(navigator.userAgent) ||
      (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)
    ) {
      const pathname = window.location.pathname;
      if (
        pathname.includes('auth') ||
        pathname.includes('course/') ||
        (pathname.includes('courses') &&
          pathname.includes('stages') &&
          !pathname.includes('feedback')) ||
        (pathname.includes('courses') &&
          pathname.includes('stages') &&
          pathname.includes('feedback'))
      ) {
        window.open(`c1do1:/${pathname}`);
      }
    }
  };

  const serverHealthCheck = async () => {
    try {
      const {
        data: { health: health },
      } = await client.query({
        query: queries.checkHealth,
        fetchPolicy: 'network-only',
      });
      setHealth(health);
    } catch (e) {
      console.log(e);
      setHealth(false);
    }
  };


  return (
    <div id='app'>
      {GA.init() && <GA.RouteTracker />}
      <I18nextProviderC>
        { health ?
        <>
          <ScrollToTop />
          <Router history={history} />
        </>
          :
          <ServerUnavailable />
        }
      </I18nextProviderC> 
        

    </div>
  );
}

export default App;
